import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["cell", "input"];

  connect() {
    console.log("category-match-matrix controller connected");
    this.inputTargets.forEach((input) => {
      input.dataset.initialValue = this.normalizedValue(input.value);
      this.updateCell(input);
    });
  }

  update(event) {
    this.updateCell(event.currentTarget);
  }

  updateCell(input) {
    const cell = input.closest("td");
    if (!cell) return;

    const value = this.clampedValue(input.value);
    cell.style.backgroundColor = this.colorFor(value);
    cell.classList.toggle(
      "is-dirty",
      this.normalizedValue(input.value) !== input.dataset.initialValue
    );
  }

  highlightCell(event) {
    this.highlightColumn(event.currentTarget.dataset.categoryMatchMatrixColumn);
  }

  highlight(event) {
    const cell = event.target.closest("[data-category-match-matrix-target~='cell']");
    if (!cell || !this.element.contains(cell)) return;

    this.highlightColumn(cell.dataset.categoryMatchMatrixColumn);
  }

  clearHighlight() {
    this.cellTargets.forEach((cell) => {
      cell.classList.remove("is-column-hovered");
    });
  }

  highlightColumn(column) {
    if (!column) return;

    this.cellTargets.forEach((cell) => {
      cell.classList.toggle(
        "is-column-hovered",
        cell.dataset.categoryMatchMatrixColumn === column
      );
    });
  }

  clampedValue(value) {
    const parsed = Number.parseFloat(value);
    if (Number.isNaN(parsed)) return 0;

    return Math.min(Math.max(parsed, 0), 1);
  }

  normalizedValue(value) {
    return this.clampedValue(value).toFixed(2);
  }

  colorFor(value) {
    // Detect dark mode based on document or body class (uses Tailwind dark mode class)
    const isDark =
      document.documentElement.classList.contains("dark") ||
      document.body.classList.contains("dark");

    if (isDark) {
      // In dark mode: 0.00 is nearly black, 1.00 is vivid green.
      // Use hsl(142, saturation%, lightness%) for green shades; gray for 0.
      if (value <= 0) {
        return "hsl(0 0% 20%)"; // very dark gray/black
      }
      const greenSaturation = 60 + value * 30;
      const greenLightness = 30 + value * 13; // 30-43%
      return `hsl(142 ${greenSaturation}% ${greenLightness}%)`;
    } else {
      // In light mode: original lighter green scale
      const lightness = 100 - value * 36;
      const saturation = value * 70;
      return `hsl(142 ${saturation}% ${lightness}%)`;
    }
  }
}
